// eslint-disable-next-line eag/no-external-date-time-format-functions -- It is intended to have custom format here
import {format} from 'date-fns';

export function getApiDateTimeString(date: Date) {
  return format(date, "yyyy-MM-dd'T'HH:mm:ssxxx");
}
